module.exports = __webpack_public_path__ + "static/media/29.1c07d6b6.jpg";